/* assets/prorate.js */
(function () {
  if (!window.PRODUCT_IS_PRORATED) {
    console.log('[PRORATE] Skipped – non-prorated product');
    return;
  }

  const LOG = (...a) => console.log('[PRORATE]', ...a);
  const BACKEND_URL = 'https://celero-soccer.onrender.com/app/prorate';

  /* -------------------------
     HELPERS
  --------------------------*/

  async function fetchJSON(url, opts = {}) {
    const r = await fetch(url, opts);
    const t = await r.text();
    return { ok: r.ok, json: t ? JSON.parse(t) : null };
  }

  function readMonth(form) {
  /* 1️⃣ Visible select (best case) */
  const selects = [...form.querySelectorAll('select')];
  for (const s of selects) {
    const val = s.value?.trim();
    if (val && /[A-Za-z]{3,9}\s\d{4}/.test(val)) {
      console.log('[PRORATE] Month from select:', val);
      return val;
    }
  }

  /* 2️⃣ properties[] inputs (Globo-safe) */
  const propInputs = [...form.querySelectorAll('[name^="properties"]')];
  for (const el of propInputs) {
    const val = el.value?.trim();
    if (val && /[A-Za-z]{3,9}\s\d{4}/.test(val)) {
      console.log('[PRORATE] Month from properties:', val);
      return val;
    }
  }

  /* 3️⃣ Label text fallback (MOST RELIABLE WITH GLOBO) */
  const monthLabel = [...document.querySelectorAll('label, div, span')]
    .map(el => el.textContent?.trim())
    .find(t => /[A-Za-z]{3,9}\s\d{4}/.test(t));

  if (monthLabel) {
    const match = monthLabel.match(/[A-Za-z]{3,9}\s\d{4}/);
    if (match) {
      console.log('[PRORATE] Month from label:', match[0]);
      return match[0];
    }
  }

  throw new Error('month_missing');
}


  function readDays(form) {
    const days = [];
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
      const label = form.querySelector(`label[for="${cb.id}"]`);
      if (label) days.push(label.innerText.trim());
    });
    return days.join(', ');
  }

  function getVariantId(form) {
    return form.querySelector('input[name="id"]')?.value;
  }

  /* -------------------------
     MAIN FLOW
  --------------------------*/

  async function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    try {
      const btn = e.currentTarget;
      const form = btn.closest('form');
      if (!form) throw new Error('form_missing');

      const variantId = getVariantId(form);
      if (!variantId) throw new Error('variant_missing');

      const month = readMonth(form);
      const days = readDays(form);

      LOG('FINAL Month:', month);
      LOG('FINAL Days:', days);

      /* Clear cart */
      await fetch('/cart/clear.js', { method: 'POST' });

      /* Add base product */
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: {
              Month: month,
              Days: days
            }
          }]
        })
      });

      const cart = (await fetchJSON('/cart.js')).json;

      /* Call backend */
      const backend = await fetchJSON(BACKEND_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cart })
      });

      if (!backend.ok || !backend.json?.variant_id) {
        throw new Error('backend_failed');
      }

      /* Replace with prorated invoice */
      await fetch('/cart/clear.js', { method: 'POST' });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(backend.json.variant_id), quantity: 1 }]
        })
      });

      window.location.href = '/checkout';

    } catch (err) {
      LOG('ERROR:', err.message);
      alert(
        err.message === 'month_missing'
          ? 'Please select a month.'
          : 'Something went wrong. Please try again.'
      );
    }
  }

  /* -------------------------
     BIND BUTTONS
  --------------------------*/

  function bind() {
    document.querySelectorAll('button[type="submit"], .product-form__submit')
      .forEach(btn => {
        if (btn.dataset.prorateBound) return;
        btn.dataset.prorateBound = '1';
        btn.addEventListener('click', handleClick);
        LOG('Bound:', btn);
      });
  }

  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  bind();
})();
